/* P8 GA4 event dispatcher (added 2026-05-08).
 * Listens for clicks on elements with data-ga-event attributes
 * and forwards to window.gtag. Fail-quiet if gtag isn't loaded
 * (e.g. blocked by ad-blockers or analytics not yet installed).
 */
(function () {
  'use strict';

  function emit(eventName, params) {
    if (typeof window.gtag !== 'function') return;
    try { window.gtag('event', eventName, params); } catch (e) { /* no-op */ }
  }

  // menu_click — every element tagged with data-ga-event="menu_click"
  document.addEventListener('click', function (e) {
    var link = e.target && e.target.closest && e.target.closest('[data-ga-event="menu_click"]');
    if (!link) return;
    emit('menu_click', {
      menu_section: link.dataset.gaSection || '',
      menu_label: link.dataset.gaLabel || (link.textContent || '').trim().slice(0, 80),
      menu_position: parseInt(link.dataset.gaPosition || '0', 10),
      page_location: window.location.href
    });
  });

  // search_open — first focus on header search input
  function wireSearchOpen() {
    var input = document.querySelector('[data-search-input], .header__search input, [type="search"]');
    if (!input) return;
    input.addEventListener('focus', function once() {
      emit('search_open', { source: 'header' });
      input.removeEventListener('focus', once);
    }, { passive: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wireSearchOpen);
  } else {
    wireSearchOpen();
  }

  // filter_apply — collection facet checkbox change
  document.addEventListener('change', function (e) {
    if (!e.target || !e.target.matches) return;
    if (!e.target.matches('.facets__checkbox, [data-facet], input[name^="filter."]')) return;
    var facetGroup = e.target.closest('.facets__details, [data-facet-group]');
    var summary = facetGroup && (facetGroup.querySelector('.facets__summary, [data-facet-name]'));
    var name = (summary && (summary.innerText || summary.textContent) || '').trim();
    var path = (window.location.pathname || '').split('/').filter(function (p) { return p; });
    emit('filter_apply', {
      filter_name: name,
      filter_value: e.target.value || '',
      collection: path[path.length - 1] || ''
    });
  });
})();
